import { FC } from "react";
import ReportLayout from "../../components/Report/ReportLayout";
import {
  reportConsiderations as allReportConsiderations,
  kpiDefinition,
} from "../about/utils";
import { FilterType } from "../../types/filters.types";

interface BuyersReportProps {
  forceScreen?: "extraSmall" | "mobile" | "desktop";
  canScanBarcode?: boolean;
  loadFilters?: FilterType[];
}

const reportConsiderations = [
  "A small portion (~1-2%) of products have incorrect CIC/CSC/UPC relationships, which may result in incorrect results when using the CIC or UPC filters",
  allReportConsiderations[2],
];

const BuyersReport: FC<BuyersReportProps> = ({
  forceScreen,
  canScanBarcode,
  loadFilters,
}) => (
  <ReportLayout
    forceScreen={forceScreen}
    canScanBarcode={canScanBarcode}
    loadFilters={loadFilters}
    kpiDefinition={kpiDefinition.slice(2)}
    reportConsiderations={reportConsiderations}
  />
);

export default BuyersReport;
